import { makeStyles } from "@material-ui/core/styles";

export const useInfiniteScrollModalStyles = makeStyles(() => ({
  scrollArea: {
    maxHeight: "60vh",
    width: "100%",
    overflow: "scroll",
  },
}));
